export const SUBTITLE_BAR_HEIGHT = 21;
export const PHONE_BAR_WIDTH = 106;
export const STAGE_SLOT_MIN_HEIGHT = 32;
export const STAGE_SLOT_MIN_WIDTH = 132;
